module.exports = __webpack_public_path__ + "img/harvest2.2f69d4b0.png";